














import { bitecBuri } from "./bitec-buri"







//prevent from removing " " from non "xxx-xxx" pattern.
// prettier-ignore
export const extensionConfigs = {
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  
  "bitec-buri": bitecBuri,
  
  
  
  
  
  
}
